import React, { useRef, useEffect, useState } from "react";
import baseVend from "../spritesheets/vendbase.png";
import Collider from "./Collider";

import { useContext } from "react";

import { EnteredContext } from "../context/EnteredContext";

export default function VendingMachine(props) {
  const canvasRef = useRef(null);
  const ctxRef = useRef(null);

  const baseVendRef = useRef(new Image());

  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [animationRunning, setAnimationRunning] = useState(false);
  const { addEntered } = useContext(EnteredContext);

  const width = 160 * 2;
  const height = 248 * 2;

  const handleClick = (e) => {
    const canvas = canvasRef.current;
    const rectBounds = canvas.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rectBounds.left,
      y: e.clientY - rectBounds.top,
    });
  };

  let currentFrame = 0; // Start from frame 0

  const catJump = () => {
    ctxRef.current.clearRect(
      0,
      0,
      canvasRef.current.width,
      canvasRef.current.height,
    ); // Clear the canvas

    ctxRef.current.drawImage(
      baseVendRef.current, // image of spritesheet
      currentFrame * width,
      0, // sx, sy (cut from spritesheet)
      width,
      height, // sw, sh (size of sprite)
      0,
      0, // dx, dy (position on canvas)
      width,
      height, // dw, dh (size on canvas)
    );

    currentFrame = currentFrame + 1;
    if (currentFrame < 14) {
      setTimeout(() => {
        requestAnimationFrame(catJump);
      }, 1000 / 15);
    }
  };

  const checkAnimationRunning = (runFunc, duration) => {
    console.log(animationRunning);
    if (animationRunning === false) {
      setAnimationRunning(true);
      runFunc();

      setTimeout(() => {
        setAnimationRunning(false);
      }, duration);
    }

    return animationRunning;
  };

  const resetDefault = () => {
    ctxRef.current.drawImage(
      baseVendRef.current, // image of spritesheet
      0 * width,
      0, // cut from spritesheet
      width,
      height, // sw, sh (size of sprite)
      0,
      0, // dx, dy
      width,
      height, // dw, dh (size on canvas)
    );
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    ctxRef.current = canvas.getContext("2d");

    baseVendRef.current.src = baseVend;

    baseVendRef.current.onload = () => {
      resetDefault();

      Collider(
        134 * 2,
        142 * 2,
        14,
        14,
        canvasRef,
        mousePos,
        checkAnimationRunning,
        resetDefault,
        catJump,
        (15 / 15) * 1000,
        true,
      );
      Collider(
        114 * 2,
        122 * 2,
        14,
        14,
        canvasRef,
        mousePos,
        null,
        false,
        addEntered,
        null,
        "A",
      );
      Collider(
        124 * 2,
        122 * 2,
        14,
        14,
        canvasRef,
        mousePos,
        null,
        false,
        addEntered,
        null,
        "B",
      );
      Collider(
        134 * 2,
        122 * 2,
        14,
        14,
        canvasRef,
        mousePos,
        null,
        false,
        addEntered,
        null,
        "C",
      );
      Collider(
        114 * 2,
        132 * 2,
        14,
        14,
        canvasRef,
        mousePos,
        null,
        false,
        addEntered,
        null,
        "D",
      );
      Collider(
        124 * 2,
        132 * 2,
        14,
        14,
        canvasRef,
        mousePos,
        null,
        false,
        addEntered,
        null,
        "1",
      );
      Collider(
        134 * 2,
        132 * 2,
        14,
        14,
        canvasRef,
        mousePos,
        null,
        false,
        addEntered,
        null,
        "2",
      );
      Collider(
        114 * 2,
        142 * 2,
        14,
        14,
        canvasRef,
        mousePos,
        null,
        false,
        addEntered,
        null,
        "3",
      );
      Collider(
        124 * 2,
        142 * 2,
        14,
        14,
        canvasRef,
        mousePos,
        null,
        false,
        addEntered,
        null,
        "4",
      );
    };
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    ctxRef.current = canvas.getContext("2d");

    Collider(
      134 * 2,
      142 * 2,
      14,
      14,
      canvasRef,
      mousePos,
      checkAnimationRunning,
      true,
      catJump,
      (15 / 15) * 1000,
      true,
    );
    Collider(
      114 * 2,
      122 * 2,
      14,
      14,
      canvasRef,
      mousePos,
      null,
      false,
      addEntered,
      null,
      "A",
    );
    Collider(
      124 * 2,
      122 * 2,
      14,
      14,
      canvasRef,
      mousePos,
      null,
      false,
      addEntered,
      null,
      "B",
    );
    Collider(
      134 * 2,
      122 * 2,
      14,
      14,
      canvasRef,
      mousePos,
      null,
      false,
      addEntered,
      null,
      "C",
    );
    Collider(
      114 * 2,
      132 * 2,
      14,
      14,
      canvasRef,
      mousePos,
      null,
      false,
      addEntered,
      null,
      "D",
    );
    Collider(
      124 * 2,
      132 * 2,
      14,
      14,
      canvasRef,
      mousePos,
      null,
      false,
      addEntered,
      null,
      "1",
    );
    Collider(
      134 * 2,
      132 * 2,
      14,
      14,
      canvasRef,
      mousePos,
      null,
      false,
      addEntered,
      null,
      "2",
    );
    Collider(
      114 * 2,
      142 * 2,
      14,
      14,
      canvasRef,
      mousePos,
      null,
      false,
      addEntered,
      null,
      "3",
    );
    Collider(
      124 * 2,
      142 * 2,
      14,
      14,
      canvasRef,
      mousePos,
      null,
      false,
      addEntered,
      null,
      "4",
    );
  }, [mousePos]);

  return (
    <div className={props.css}>
      <canvas
        ref={canvasRef}
        width={160 * 2}
        height={248 * 2}
        onClick={handleClick}
      ></canvas>
    </div>
  );
}
